import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { OrderDirection } from '../types/app';
import { Journey, JourneyCore, JourneySortOption, TravelRow } from '../types/journey';
import { deleteRequest, getRequest, postRequest } from './api';
import { journeyUrl, journeysUrl, travelUrl } from './urls/journeyUrls';

export const getJourneys = async ({
  clientId,
  subClientId,
  order,
  orderBy,
  search,
  status,
}: {
  clientId: string;
  subClientId: string;
  order?: OrderDirection;
  orderBy?: JourneySortOption;
  search?: string;
  status?: number;
}): Promise<{ journeys?: Journey[]; error?: ApiError }> => {
  const queryParams = {
    clientId,
    subClientId,
    all_items: true,
    search,
    status,
    order,
    orderBy,
  };
  const response = await getRequest(journeysUrl, { queryParams });
  return {
    journeys: response?.data?.items,
    error: response?.error,
  };
};

export const getJourney = async (
  clientId: string,
  subClientId: string,
  journeyId: string
): Promise<{ journey?: Journey; error?: ApiError }> => {
  const response = await getRequest(journeyUrl(journeyId), { queryParams: { clientId, subClientId } });

  return {
    journey: response?.data,
    error: response?.error,
  };
};

export const deleteJourney = async (
  clientId: string,
  subClientId: string,
  journeyId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(journeyUrl(journeyId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateJourney = async (
  clientId: string,
  subClientId: string,
  journey: JourneyCore
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(journeyUrl(journey._id), {
    body: { ...journey, subClientId, clientId, asset: journey.asset?._id },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postJourney = async (
  clientId: string,
  subClientId: string,
  journey: JourneyCore
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(journeysUrl, {
    body: { ...journey, subClientId, clientId, asset: journey.asset?._id },
  });

  return {
    id: response?.data?._id,
    error: response?.error,
  };
};

export const getTravel = async (journey: JourneyCore): Promise<{ rows?: TravelRow[]; error?: ApiError }> => {
  if (!journey.startPoint || !journey.endPoint || !journey.startDate) {
    return { error: 'Faltan datos para obtener la información del viaje.' };
  }
  const response = await postRequest(
    travelUrl,
    {
      body: {
        origins: [[journey.startPoint.lat, journey.startPoint.lng]],
        destinations: [[journey.endPoint.lat, journey.endPoint.lng]],
        departureTime: journey.startDate,
      },
    },
    ApiEndpoint.core
  );

  return {
    rows: response?.data?.rows,
    error: response?.error,
  };
};
